{
  "kind": {
    "ssh": "terminal",
    "rdp": "remote desktop",
    "vnc": "console"
  },
  "state": {
    "connecting": "Connecting…",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "error": "Error"
  },
  "tabsLabel": "Sessions",
  "phoneButton": "Sessions ({{count}})",
  "tabName": "{{name}}, {{kind}}: {{status}}",
  "tabNameUnseen": "{{name}}, {{kind}}: {{status}}, new output",
  "unseen": "New output",
  "minimised": "minimised",
  "close": "Close {{name}}",
  "moveHint": "Ctrl+Shift+Left or Right arrow moves the tab; right-click opens the tab's menu.",
  "moved": "{{name}}: place {{position}} of {{count}}",
  "menu": {
    "moveLeft": "Move left",
    "moveRight": "Move right",
    "serverPage": "Open the server's page",
    "closeOthers": "Close others"
  },
  "toolbar": "Session controls",
  "toServer": "Open the page of server {{name}}",
  "zones": {
    "session": "Session",
    "tools": "Tools",
    "window": "Window"
  },
  "tools": {
    "keyboard": "Keyboard",
    "typeText": "Type text",
    "paste": "Paste from clipboard",
    "combos": "Key combinations",
    "fit": "Fit",
    "actual": "1:1",
    "settings": "Session settings",
    "reconnect": "Reconnect",
    "disconnect": "Disconnect",
    "fullscreen": "Full screen",
    "exitFullscreen": "Exit full screen",
    "minimise": "Minimise into the tab"
  },
  "reconnect": {
    "title": "Reconnect to {{name}}?",
    "ssh": "The current session will be closed: programs running in it will end.",
    "vnc": "The console will reconnect.",
    "rdp": "The desktop session will reconnect; you will need the password again."
  },
  "restored": {
    "title": "Enter the password to reconnect",
    "ssh": "The page was reloaded. This terminal signed in with a password, and passwords are never kept: enter it again.",
    "rdp": "The page was reloaded. The Windows password is never kept: enter it again."
  },
  "gone": {
    "title": "Server not found",
    "text": "Server {{name}} no longer exists, or you no longer have access to its project. Close the tab.",
    "close": "Close the tab"
  },
  "power": {
    "menu": "Power",
    "powerOn": "Power on",
    "shutdown": "Shut down",
    "powerOff": "Power off",
    "reboot": "Reboot",
    "rebootHint": "A soft reboot: if the system hangs, use “Hard reset”",
    "reset": "Hard reset"
  },
  "combos": {
    "send": "Send {{keys}}"
  },
  "typeText": {
    "desktop": "Each character is typed on the desktop with keys. You press Enter — or tick it below."
  },
  "pasteFailed": "The browser did not let us read the clipboard. Paste the text into the field yourself.",
  "problem": "Could not open the session",
  "workspace": {
    "title": "Sessions",
    "titleOf": "Session {{name}}",
    "emptyTitle": "No open sessions",
    "emptyText": "Connect to a server: a terminal, a desktop or a console opens here and keeps running while you move around the panel."
  },
  "insert": {
    "into": "Paste into the open session {{name}}",
    "hint": "The command appears in the open session; you press Enter once you have read it.",
    "newTerminal": "Open a new terminal",
    "newConsole": "Open a new console"
  },
  "settings": {
    "title": "Session settings",
    "vncLead": "Which layout text is typed in. For every console in this browser.",
    "rdpLead": "Which keyboard layout Windows expects. For every desktop in this browser.",
    "layout": "Keyboard layout",
    "console": {
      "us": "English (US)",
      "usHint": "As Hetzner's console has it by default",
      "ru": "Russian (ЙЦУКЕН)",
      "ruHint": "When the server is switched to the Russian layout: Cyrillic letters type, Latin ones do not"
    },
    "rdp": {
      "default": "The gateway's (English US)",
      "en-us-qwerty": "English (US)",
      "en-gb-qwerty": "English (UK)",
      "de-de-qwertz": "German",
      "fr-fr-azerty": "French",
      "it-it-qwerty": "Italian",
      "es-es-qwerty": "Spanish",
      "sv-se-qwerty": "Swedish",
      "ja-jp-qwerty": "Japanese",
      "failsafe": "Universal (Unicode, Cyrillic included)"
    },
    "rdpLayoutHint": "The layout applies at the next sign-in: reconnect."
  },
  "pair": {
    "on": "the Autopilot has access to this session",
    "running": "The Autopilot runs: {{command}}",
    "access": "The Autopilot has access to the terminal: {{level}}"
  }
}
